(function () {
  var root = document.querySelector('[data-rpm-inv]');
  if (!root) return;
  var grid = root.querySelector('[data-rpm-grid]');
  var cards = [].slice.call(grid.querySelectorAll('[data-rpm-card]'));
  function f(n) { return root.querySelector('[data-f="' + n + '"]'); }
  var q = f('q'), make = f('make'), body = f('body'), year = f('year'), price = f('price'), miles = f('miles'), sort = f('sort');
  var count = root.querySelector('[data-count]'), empty = root.querySelector('[data-empty]'), reset = root.querySelector('[data-reset]');

  function uniq(attr) {
    var s = {};
    cards.forEach(function (c) { var v = c.getAttribute(attr); if (v) s[v] = 1; });
    return Object.keys(s);
  }
  function fill(sel, vals, fmt) {
    vals.forEach(function (v) {
      var o = document.createElement('option');
      o.value = v; o.textContent = fmt ? fmt(v) : v; sel.appendChild(o);
    });
  }
  fill(make, uniq('data-make').sort());
  fill(body, uniq('data-body').sort());
  fill(year, uniq('data-year').sort().reverse(), function (v) { return v + ' and newer'; });

  function setSel(sel, val) {
    if (!val) return;
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value.toLowerCase() === val.toLowerCase()) { sel.selectedIndex = i; return; }
    }
  }
  var p = new URLSearchParams(location.search);
  if (p.get('q')) q.value = p.get('q');
  setSel(make, p.get('make'));
  setSel(body, p.get('body'));

  function num(c, a) { return parseInt(c.getAttribute(a), 10) || 0; }
  var keys = {
    'new': function (c) { return num(c, 'data-index'); },
    'price-asc': function (c) { return num(c, 'data-price'); },
    'price-desc': function (c) { return -num(c, 'data-price'); },
    'year-desc': function (c) { return -num(c, 'data-year'); },
    'miles-asc': function (c) { return num(c, 'data-miles') || 9999999; }
  };

  function run() {
    var t = q.value.trim().toLowerCase();
    var shown = 0;
    cards.forEach(function (c) {
      var ok = true;
      if (t && (c.getAttribute('data-title') || '').indexOf(t) === -1) ok = false;
      if (make.value && c.getAttribute('data-make') !== make.value) ok = false;
      if (body.value && c.getAttribute('data-body') !== body.value) ok = false;
      if (year.value && num(c, 'data-year') < parseInt(year.value, 10)) ok = false;
      if (price.value && (num(c, 'data-price') > parseInt(price.value, 10))) ok = false;
      if (miles.value && (!num(c, 'data-miles') || num(c, 'data-miles') > parseInt(miles.value, 10))) ok = false;
      c.hidden = !ok;
      if (ok) shown++;
    });
    var k = keys[sort.value] || keys['new'];
    cards.slice().sort(function (a, b) { return k(a) - k(b); }).forEach(function (c) { grid.appendChild(c); });
    count.textContent = shown;
    empty.hidden = shown !== 0;
    var np = new URLSearchParams();
    if (t) np.set('q', q.value.trim());
    if (make.value) np.set('make', make.value);
    if (body.value) np.set('body', body.value);
    var qs = np.toString();
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : ''));
  }
  [q, make, body, year, price, miles, sort].forEach(function (el) {
    el.addEventListener(el === q ? 'input' : 'change', run);
  });
  reset.addEventListener('click', function () {
    q.value = ''; [make, body, year, price, miles].forEach(function (s) { s.selectedIndex = 0; });
    sort.selectedIndex = 0; run();
  });
  run();
})();
